import styled from 'styled-components';

export const GraphCaption = styled.div`
  font-size: 0.75rem;
  white-space: nowrap;
  writing-mode: vertical-rl;
  display: block;
  font-weight: 300;
  transform: rotate(180deg);
`;
